import { render, staticRenderFns } from "./EditDispatchConfig.vue?vue&type=template&id=7d7c8453&"
import script from "./EditDispatchConfig.vue?vue&type=script&lang=js&"
export * from "./EditDispatchConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports